import React from 'react';
import { FaPlaneDeparture } from 'react-icons/fa'; // Using an icon from your dependencies

const SimbriefButton = ({ origin, destination, aircraftType }) => {
  
    const handleOpenSimbrief = () => {
        // Base SimBrief new flight URL
        const baseUrl = "https://dispatch.simbrief.com/options/custom";
        
        // Construct URL parameters safely
        const params = new URLSearchParams();
        
        if (origin) params.append('orig', origin.toUpperCase());
        if (destination) params.append('dest', destination.toUpperCase());
        if (aircraftType) params.append('type', aircraftType.toUpperCase());

        params.append('fltnum', randomFlightNumber())
        params.append('airline', "FDX")
        params.append('acdata', `{"extrarmk": "RMK/ FedEx Express Virtual - FDXVA.ORG"}`)

        // Combine base URL with parameters
        const fullUrl = `${baseUrl}?${params.toString()}`;

        // Open in a new tab securely
        window.open(fullUrl, '_blank', 'noopener,noreferrer');
    };

    const randomFlightNumber = () =>{
        const randomNumber = Math.floor(Math.random() * 9999);
        return `${randomNumber}`;
    }

    return (
        <button 
        onClick={handleOpenSimbrief}
        style={styles.simbrief_button} // You can replace this with your own CSS classes
        >
        <FaPlaneDeparture style={{ marginRight: '8px' }} />SimBrief</button>
    );



}
    // Basic inline styling (feel free to replace with CSS/Tailwind/Styled Components)
const styles = {
    simbrief_button: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        padding: '10px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold'
    }
};
export default SimbriefButton;